import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
  Stack,
  Avatar
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface AdminData {
  adminUserName: string;
  email: string;
  mobileNumber: string;
}

interface ViewAllSpocModalProps {
  open: boolean;
  onClose: () => void;
  spocList: AdminData[];
  onAddNew: () => void;
}

const ViewAllSpocModal: React.FC<ViewAllSpocModalProps> = ({
  open,
  onClose,
  spocList,
  onAddNew
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: 600
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          py: 2
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "#212121"
          }}
        >
          SPOCs
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            onClick={onAddNew}
            sx={{
              fontSize: 14,
              fontWeight: 500,
              color: "#3A1C73",
              textTransform: "none",
              p: 0,
              minWidth: "auto"
            }}
          >
            Add New
          </Button>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ color: "#212121", p: 0 }}
          >
            <CloseIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Box>
      </Box>

      <Divider />

      {/* Content */}
      <DialogContent
        sx={{
          py: 3,
          px: 3
        }}
      >
        <Stack spacing={3}>
          {spocList.map((spoc, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
                <Avatar
                  sx={{
                    width: 48,
                    height: 48,
                    bgcolor: index === 0 ? "#CAC317" : index === 1 ? "#16A34A" : "#FF9800",
                    fontSize: 16,
                    fontWeight: 700,
                    flexShrink: 0
                  }}
                >
                  {spoc.adminUserName.substring(0, 2).toUpperCase()}
                </Avatar>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#212121",
                      lineHeight: 1.2
                    }}
                  >
                    {spoc.adminUserName}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: "#9CA3AF",
                      lineHeight: 1.4,
                      mt: 0.3
                    }}
                  >
                    {spoc.email} | {spoc.mobileNumber}
                  </Typography>
                </Box>
              </Box>
              <IconButton
                size="small"
                sx={{ color: "#3A1C73", p: 0.5, flexShrink: 0 }}
              >
                <MoreVertIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Box>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAllSpocModal;
